import API from './axios.js';

export const getExpensesByCourtRef = (courtref) =>API.get(`expense/expense-by-court-ref/${courtref}`);
export const getExpenseByUser = (queryParams = '') => API.get(`expense${queryParams}`);
export const getExpenseByID = (expID) => API.get(`expense/${expID}`);
// http://localhost:5000/expense/68184faf3308d4fc116f3614
export const saveExpense = (expenseData) => API.post('expense', expenseData);
export const updateExpense = (expenseData,id) => API.patch(`expense/${id}`, expenseData);
export const deleteExpense = (id) => API.delete(`expense/${id}`);